import { SAVE_SUBSIDIARY_INFO } from "../constants";

export const saveSubsidiaryInfo = (subsidiaryInfo: any) => {
  return {
    type: SAVE_SUBSIDIARY_INFO,
    subsidiaryInfo,
  };
};
